import { InjectionToken } from "@angular/core";

export const NON_PHI_FAX_ORIGIN_TOKEN = new InjectionToken<string>("NON_PHI_FAX_ORIGIN_TOKEN");
